import React from 'react'
import { InfoContainer, InfoRow, Column1, TextWrapper, Column2, ImgWrap, TopLine, Subtitle } from './InfoElements'
import Infopic from '../../images/infopic.png'
import './info.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'


const Info1 = ({topLine}) => {
    useEffect(()=>{
        AOS.init();
    });
    return (
        <InfoContainer id="Intro">
            <TopLine>{topLine}</TopLine>
            
            <InfoRow imgStart={true}>
                
                        <Column1>
                        <TextWrapper>
                            <Subtitle data-aos="fade-up" data-aos-delay="100" darkText={false}>
                            Dinomension is a collection of unique NFTs on the Ethereum blockchain. 5000 dinos are released in the first phase. Every NFT is generated from some of the 180+ hand-drawn elements. The concept of The Dinomension is based on an interactive comic story – <span style={{fontWeight:"1000"}}>The DNMS Journal</span> and its mission is to integrate the metaverse into reality. 
<br /><br />
Owning a NFT qualifies you as a DNMS citizen. Citizens can co-create <span style={{fontWeight:"1000"}}>The DNMS Journal</span> with other Dino fellows. Still, you will be able to enter citizens-only area and enjoy benefits from and beyond the roadmap. 
                            </Subtitle>
                        </TextWrapper>
                        </Column1>
                        <Column2>
                            <ImgWrap>
                            {/* <a href="https://imgur.com/rqF2bA0"><img src="https://i.imgur.com/rqF2bA0.png" title="source: imgur.com" /></a> */}
                                <img src="https://i.imgur.com/rqF2bA0.png" className="infopic"></img>
                            </ImgWrap>
                        </Column2>
                    </InfoRow>
        </InfoContainer>
    )
}

export default Info1
